export default {
      id: "icon--chevron-right-black-usage",
      viewBox: "0 0 11 11",
      url: __webpack_public_path__ + "sprite.svg#icon--chevron-right-black",
      toString: function () {
        return this.url;
      }
    }